// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"51cff255290e0b19","8932":"b39dbd97004bc4b5"}[chunkId] + ".css";
};